import { IRuleOptions, IValidationOptions, IValidationRule, RuleName } from "./Validator";

export class IsGreaterThanRule implements IValidationRule
{
    public rule: RuleName = 'IsGreaterThan';
    private value: number;
    private errorLabel: string;
    
    constructor(value: number, validationOptions: IValidationOptions, ruleOptions: IRuleOptions = {})
    {
        this.value = value;
        this.errorLabel = ruleOptions.errorLabel ?? validationOptions.mustBeGreaterThanLabel ?? validationOptions.invalidFieldLabel;
    }

    public validate(value: string): string
    {
        if (Number.parseFloat(value) > this.value)
        {
            return '';
        }
        return this.errorLabel;
    }
}
